import { render, staticRenderFns } from "./ClientDetailsModal.vue?vue&type=template&id=40df71ce&scoped=true"
import script from "./ClientDetailsModal.vue?vue&type=script&lang=js"
export * from "./ClientDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ClientDetailsModal.vue?vue&type=style&index=0&id=40df71ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df71ce",
  null
  
)

export default component.exports